'use client';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export function AuthPageSkeleton({
  titleWidth = 'w-48',
  descriptionLines = 2,
}: {
  titleWidth?: string;
  descriptionLines?: number;
}) {
  return (
    <div className="flex min-h-[calc(100vh-160px)] items-center justify-center p-6">
      <Card className="w-full max-w-md border border-border/60/70 dark:border-white/10 shadow-xl bg-card backdrop-blur-xl">
        <CardHeader className="space-y-2">
          <CardTitle>
            <Skeleton className={`h-6 ${titleWidth}`} />
          </CardTitle>
          <CardDescription>
            <div className="space-y-2">
              {Array.from({ length: descriptionLines }, (_, index) => `auth-desc-${index}`).map((key) => (
                <Skeleton key={key} className="h-4 w-full" />
              ))}
            </div>
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Skeleton className="h-10 w-full rounded-lg" />
          <Skeleton className="h-10 w-full rounded-lg" />
          <Skeleton className="h-10 w-full rounded-lg" />
        </CardContent>
      </Card>
    </div>
  );
}

export default AuthPageSkeleton;
